<template>
  <a-locale-provider :locale="zh_CN">
    <div id="app">
      <router-view />
    </div>
  </a-locale-provider>
</template>

<script>
// eslint-disable-next-line
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { deviceEnquire } from '@/utils/device'

export default {
  name: 'app',
  data () {
    return {
      zh_CN
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag
    }
  },
  mounted () {
    if (this._isMobile()) {
      this.$router.replace('/mobileIndex')
    } else {
      deviceEnquire(deviceType =>
        this.$store.commit('app/SET_DEVICE', deviceType)
      )
    }
    // deviceEnquire(deviceType =>
    //   this.$store.commit('app/SET_DEVICE', deviceType)
    // )
  }
}
</script>
